import { ServiceRequestParam } from './service-request-param';

export class ServiceRequest{
    constructor(){
        this.data = new ServiceRequestParam();
    }

    data : ServiceRequestParam;
}